export const resumeConstants = { 
    SET_RESUME: 'SET_RESUME'
}